import React from 'react';

import Label from '../components/Label';
import getDueDateLabel from './getDueDateLabel';

const getTaskStatusLabel = (task: any) => {
  if (task.completedDatetime) {
    return (
      <Label color="success">
        Complete
      </Label>
    );
  }

  return getDueDateLabel(task.dueDate);
};

export default getTaskStatusLabel;
